import script from "./InvitationAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationAccept.vue?vue&type=script&setup=true&lang=js"

import "./InvitationAccept.vue?vue&type=style&index=0&id=0fd97155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd97155"]])

export default __exports__